(() => {
  const data = document.querySelector('[data-en-welcome-config]');
  if (!data) return;
  const config = JSON.parse(data.textContent);
  const popup = document.querySelector('[data-en-welcome]');
  const root=(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const code=config.discountCode;
  const discountUrl=path => root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(path);
  document.querySelectorAll('[data-en-welcome-continue]').forEach(link=>{
    link.href=discountUrl(location.pathname+location.search);
  });
  async function applyWelcome(){
    if(!config.live || !code)return;
    try{
      const response=await fetch(discountUrl(root+'cart.js'),{credentials:'same-origin'});
      if(response.ok)document.dispatchEvent(new CustomEvent('cart:build'));
    }catch(_){ /* Continue shopping remains an official Shopify discount link. */ }
  }
  let previousFocus;
  const stored = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const remember = (key,value) => { try { localStorage.setItem(key,value); } catch (_) {} };
  const open = () => { if (!popup.open) { previousFocus=document.activeElement; popup.showModal(); } };
  const close = () => { popup.close(); remember('earthle-welcome-dismissed',String(Date.now())); previousFocus?.focus(); };
  document.querySelectorAll('[data-en-welcome-open]').forEach(button=>button.addEventListener('click',()=>{
    popup.querySelector('[data-en-welcome-entry]').hidden=false;
    popup.querySelector('[data-en-welcome-success]').hidden=true;
    open();
  }));
  document.querySelectorAll('[data-en-welcome-close]').forEach(button=>button.addEventListener('click',close));
  popup.addEventListener('cancel',event=>{event.preventDefault();close();});
  popup.addEventListener('click',event=>{if(event.target===popup){const b=popup.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)close();}});
  document.querySelectorAll('[data-en-signup]').forEach(form=>form.addEventListener('submit',async event=>{
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button=form.querySelector('[type=submit]');
    const status=form.querySelector('[data-en-signup-status]');
    button.disabled=true;status.textContent='';
    try {
      if(config.live){
        const response=await fetch('https://a.klaviyo.com/client/subscriptions?company_id='+config.site,{
          method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2026-10-15'},
          body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Earthle newsletter '+config.language,profile:{data:{type:'profile',attributes:{email:form.elements.email.value.trim(),locale:config.language,properties:{'Earthle language':config.language,'Earthle welcome subject':config.subject},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:config.list}}}}})
        });
        if(response.status!==202)throw new Error();
        remember('earthle-welcome-subscribed','1');
        void applyWelcome();
      }
      popup.querySelector('[data-en-welcome-entry]').hidden=true;
      popup.querySelector('[data-en-welcome-success]').hidden=false;
      status.textContent=config.success;
      open();
    } catch (_) { status.textContent=config.error; }
    finally {button.disabled=false;}
  }));
  const dismissed=Number(stored('earthle-welcome-dismissed')||0);
  if(!stored('earthle-welcome-subscribed')&&Date.now()-dismissed>5*86400000){
    const offer=()=>{
      const cookieBanner=document.querySelector('#shopify-pc__banner');
      if(document.querySelector('dialog[open]') || (cookieBanner && cookieBanner.getBoundingClientRect().height>0 && getComputedStyle(cookieBanner).visibility!=='hidden')){
        setTimeout(offer,5000);
        return;
      }
      open();
    };
    setTimeout(offer,30000);
  }
  // Keep the dialog inside the visible mobile viewport while the keyboard is open.
  function viewport(){const v=window.visualViewport;popup.style.setProperty('--en-viewport-height',(v?.height||innerHeight)+'px');popup.style.setProperty('--en-viewport-top',(v?.offsetTop||0)+'px');}
  window.visualViewport?.addEventListener('resize',viewport);window.visualViewport?.addEventListener('scroll',viewport);viewport();
})();
